import React from 'react'
import { useTranslation } from "react-i18next";
import { Controller } from 'react-hook-form'

import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles(theme => ({
  label: {
    color: '#9c9c9c',
    '&.MuiFormLabel-filled': {
      display: 'none',
    },
    '&.MuiFormLabel-root.Mui-focused': {
      color: '#9c9c9c',
    },
    '&.MuiFormLabel-root.Mui-error': {
      color: '#9c9c9c',
    },
  },
}))

export default function CustomSelect({ id, label, options, control, rules, error, helperText }) {
  const { t } = useTranslation();
  const classes = useStyles()
  const { spacing } = useTheme()

  return (
    <div style={{ padding: spacing(2, 0) }}>
      <Typography variant="caption" color={error === undefined ? 'textSecondary' : 'error'}>
        {label}
      </Typography>
      <FormControl style={{ marginTop: spacing(-4), width: '100%' }} error={error !== undefined}>
        <InputLabel id={`${id}-label`} shrink={false} className={classes.label}>
            {t("Word.PleaseSelect")}
        </InputLabel>
        <Controller
          as={
            <Select
              color="secondary"
              labelId={`${id}-label`}
              id={id}
              placeholder={t("Word.PleaseSelect")}
            >
              {options.map(({ label, value }) => (
                <MenuItem key={value} value={value}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          }
          onChange={([e]) => e.target.value}
          defaultValue=""
          control={control}
          name={id}
          rules={rules}
        />
        {Boolean(helperText) && <FormHelperText>{helperText}</FormHelperText>}
        {error && <FormHelperText error>必須項目です</FormHelperText>}
      </FormControl>
    </div>
  )
}
